export async function fetchAuthApiSession(origin: string): Promise<{ signedIn: boolean }> {
  const response = await fetch(`${origin}/api/session`, {
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  if (!response.ok) {
    throw new Error(`auth api session request failed: ${response.status}`);
  }
  const body = (await response.json()) as { signedIn?: boolean };
  return { signedIn: Boolean(body.signedIn) };
}
